import { FC, PropsWithChildren } from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSection } from 'store/useBusinessToolStore/selectors';

import { useBusinessToolAiContext } from '../BusinessToolAiProvider';

import styles from './BusinessToolFormContainer.module.scss';

export const BusinessToolFormContainer: FC<PropsWithChildren> = ({ children }) => {
  const { loadingStates } = useBusinessToolAiContext();
  const activeSection = useBusinessToolStore(getActiveSection);

  const isLoading = loadingStates[activeSection];

  return <Box className={clsx(isLoading && styles.backing)}>{children}</Box>;
};
